import { render, staticRenderFns } from "./application-footer.vue?vue&type=template&id=263e9d34"
import script from "./application-footer.vue?vue&type=script&lang=js"
export * from "./application-footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports